const ACTIVE_COMPANY_KEY = "basiq_active_company";

export const getActiveCompanyId = () => localStorage.getItem(ACTIVE_COMPANY_KEY) || null;
export const setActiveCompanyId = (id) => {
  if (id) localStorage.setItem(ACTIVE_COMPANY_KEY, id);
  else localStorage.removeItem(ACTIVE_COMPANY_KEY);
};

// Map a backend company doc into the `profile` shape existing components expect.
export const companyToProfile = (c) => {
  if (!c) return null;
  const theme = c.theme || {};
  return {
    logo: c.logo || null,
    font: theme.font || "sans",
    colors: { primary: theme.primary || "#0f172a" },
    company: c.company || {},
    layout: c.layout || "minimal_classic",
    doc: c.doc || {
      cover: theme.cover ?? false,
      coverTitle: theme.coverTitle || "Proposta Comercial",
      headerLabel: theme.headerLabel || "Orçamento",
      logoRight: theme.logoRight ?? false,
      logoSize: theme.logoSize || "md",
    },
  };
};

// Map onboarding output into a backend company payload.
export const onboardingToCompany = (p) => ({
  name: p.company?.name || "",
  company: { ...(p.company || {}), logo: p.logo || null },
  theme: {
    primary: p.colors?.primary || "#0f172a",
    font: p.font || "sans",
    headerLabel: p.doc?.headerLabel || "Orçamento",
    logoRight: p.doc?.logoRight ?? false,
    logoSize: p.doc?.logoSize || "md",
    cover: p.doc?.cover ?? false,
    coverTitle: p.doc?.coverTitle || "Proposta Comercial",
    avatarBg: p.avatarBg || null,
  },
  layout: p.layout || "minimal_classic",
  doc: p.doc || {},
  logo: p.logo || null,
});
